import { AnyAction } from "redux";
import { actionCreator } from "@ps/utils";
import ActionTypes from "./actionTypes";

export const setMenuOpened = (): AnyAction =>
  actionCreator(ActionTypes.SET_MENU_OPENED);

export const setMenuHidden = (): AnyAction =>
  actionCreator(ActionTypes.SET_MENU_HIDDEN);
